const TRACK_NAME = '[stories]';

export const trackEvent = (eventName, props = {}) => {
  window.analytics.track(
    `${TRACK_NAME} ${eventName}`,
    {
      appName: 'Stories',
      screen: {
        width: window.innerWidth,
        height: window.innerHeight,
      },
      ...props,
    },
    {
      integrations: {
        // we don't want to send all events to Intercom
        Intercom: false,
      },
    },
  );
};

export const identify = user => {
  const identifyOptions = {
    Intercom: {
      hideDefaultLauncher: true,
    },
  };

  window.analytics.identify(
    user.user_id,
    {
      email: user.email,
      userId: user.user_id,
      organizationId: user.organization_id,
      programId: user.program_id,
      roleLevel: user.role_level,
      workspaceId: user.pl_workspace,
      projectId: user.pl_project,
      sh_user_id: user.sh_user_id,
      name: user.name,
      firstName: user.first_name,
      lastName: user.last_name,
    },
    identifyOptions,
    () => {
      trackEvent('Logged In');
    },
  );
};

export const reset = () => analytics.reset();
